import { createSelector } from '@reduxjs/toolkit';
import { selectExchanges } from 'src/store/shared/exchange-list/selectors';
import type { ArbitrageInfoState } from './types';

export interface Store {
  arbitrageInfo: ArbitrageInfoState;
}

export const selectArbitrageInfoTotal = (state: Store) => state.arbitrageInfo.total;
export const selectArbitrageInfoAccounts = (state: Store) => state.arbitrageInfo.accounts;
export const selectArbitrageInfoStatus = (state: Store) => state.arbitrageInfo.status;

export const selectArbitrageInfoData = createSelector(
  selectArbitrageInfoAccounts,
  selectExchanges,
  (accounts, exchanges) =>
    accounts.map((account) => {
      const exchange = exchanges.find((entry) => entry.id === account.exchangeID);
      return { ...account, exchange };
    }),
);
